import { AxiosInstance } from 'axios';

import CompanyApi from './CompanyApi';

class CompanyRepository {
  companyApi: CompanyApi;

  constructor(axiosInstance: AxiosInstance) {
    this.companyApi = new CompanyApi(axiosInstance);
  }

  getCompanyContact(company: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.companyApi
        .getCompanyContact(`${company}`)
        .then((data: any) => {
          resolve(data.results);
        })
        .catch(() => {
          console.error('Error al obtener el contacto de la empresa');
          reject();
        });
    });
  }
}

export default CompanyRepository;
